var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContentImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58 58",
    style: {
      enableBackground: "new 0 0 58 58"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "content_image",
    d: "M57,6H1C0.4,6,0,6.4,0,7v44c0,0.6,0.4,1,1,1h56c0.6,0,1-0.4,1-1V7C58,6.4,57.6,6,57,6z M56,50H2V8h54V50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_image",
    d: "M16,28.1c3.1,0,5.6-2.5,5.6-5.6c0-3.1-2.5-5.6-5.6-5.6s-5.6,2.5-5.6,5.6S12.9,28.1,16,28.1z M16,19 c2,0,3.6,1.6,3.6,3.6S18,26.1,16,26.1s-3.6-1.6-3.6-3.6S14,19,16,19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "content_image",
    d: "M7,46c0.2,0,0.5-0.1,0.7-0.2L24,31.4l10.3,10.3c0.4,0.4,1,0.4,1.4,0s0.4-1,0-1.4l-4.8-4.8l9.2-10.1l11.3,10.3 c0.4,0.4,1,0.3,1.4-0.1c0.4-0.4,0.3-1-0.1-1.4l-12-11C40.5,23.1,40.2,23,40,23c-0.3,0-0.5,0.1-0.7,0.3l-9.8,10.7l-4.7-4.7 c-0.4-0.4-1-0.4-1.4,0l-17,15c-0.4,0.4-0.5,1-0.1,1.4C6.4,45.9,6.7,46,7,46z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentImage);
export default __webpack_public_path__ + "static/media/content_image.28a529f5909fa88573ea5f6fc840f1c8.svg";
export { ForwardRef as ReactComponent };